import React from "react";
import styled from "styled-components";
import getConfig from "next/config";

import { hexToRGBA } from "../../../../utils/theme";
import Link from "next/link";
import LinkButton from "../../styled/LinkButton";

const { publicRuntimeConfig } = getConfig();

const StyledApplicationStepsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5rem;

  background: #FFFFFF;
  .howItWorks__title {
    margin-bottom: 50px;
    font-size: 38px;
    font-weight: 700;
    text-align: center;
    color: #39393d;
    font-family: RobotoBold, sans-serif;
  }
  .howItWorks__steps {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: column nowrap;
  }
  .howItWorks__step-title {
    min-height: 60px;
    margin-bottom: 12px;
    font-size: 21px;
    font-family: RobotoBold, sans-serif;
  }
  .howItWorks__step-body {
    font-size: 16px;
  }
  .howItWorks__step--one {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABPCAIAAAD3BgWJAAAFNElEQVR4Ae2bBXfjOBDH7xMuM5SZmZmZmZmZmZmZmZkDjuFu3uo2r01S7+ac9Gqv9f4FVSPZP6sCzyh//f1HJh6bk4nH5rF5bB6bx+axcZwoLK3SM7F79VHn5QdttujNZ10LO/eu3sH/iB0SkQCtsFfVdS1KY88vLKPK+qZ2CanZyem5bFFMYvonDWO48w/fDXGcUA67tLIOYW/v7LFuJDe1dqGbv7y8Ug67sKQK1by7E7AOe2xiGt382fkFI2z47hsUZWrt4uwReHB4TJJkdEI6ZG2cvOcXV8CgoKTSzMbV0t69u3eQO9jDo5MoCyqvbjg4PJJmo+PTKIp6+0UPZe1cfLmDLcawuKRMd5+QkMiE84tL4MwtLIMs/Atsbu2AQUNzu4dvqJd/+PjkDLuw+bHNY/sFRweFx7FLju7+TLHZLAbYmvqWWgZW7NJXbTN+bPPYPDaPzWPz2Dz276U9wWnP8TRzjZwtEhTBDuxbXPi5z/ttj5tKVLjV9qTYA0NjUM3QwpGiKKUuuSs4URUzKGqp9EmxIe0fHAmEQoVFJElt7+61dvSALwWeC6ewZdLV9c3I2FReUTm4Ez5rmUi3++BX4BS2BMdXVtdrG1rDo5MNzR2knDKampl/MJ+pFDv6abCPT057+ofTsgodXP3efdVXyKlpYOUfEgP+Q/gdAiYCwYOBICFxi9EolTC/63HvOp5UC7ZQJJqZXQCvOJDAO6ZCTuB3cPODZ9HbPwzPBVW0dvCEIvCWKhj5FHmJ3VwwlgAXqX7dJgjCNyjy9ScdhaiG5o7hMcl1ja0rqxs4jsu0KxZjbz7pgllsYgbLtivQbzKorl5BeUUVMG9dX9/Qtzu3sISqNLd1sW+XBtPVFy1TKbaBmQOsSQTx641RRXUDqgLeYvZho3AHbMjk4UmSpGk3KCwOLD9qGIEZy7Dp4XMKymja1TayARs372AuvIpAcAuCo6hCVl7xY2anZ+c/H43iRVWA4ae3YhXqToyrCxumMUt7D2QNMR0Mkzxm2T84isyGRibkS3GSmtu/nFW1MJxkhM2QGVJmbjGyvLi8ki8V44TKmUECDGeEzZAZkrNHADrlAL+zpreVZYb4JoRXUjPzKYpCm5z33wzAODQy8bGrCjHi/E6sQqGuZoStLLOJlTMy6BsYgb+srW/9PBDTzDankvLMIHNbN+hwiGOj7OLyGquwlWfW0LOQdnhUXCr8AmcXMImEfdhO7gG/yRwYFguV0XoOHW5k4QS/2Dn7sNJzqmNkgwoKS6vpmdHRrsycIshKlZKRJ79uwdyjVl3AzEaSjLBhZH7SNEZlpRV19MyQLq+uUYcjyRxthCl+4fAKlhl1a+v8jgk2Il+9T07DDEmmww+Pjh9gU5S6gZHWTm4YYsuSZ+eX0jDf7/DvehbA+T/19i1zbFny+8xisbi8qkHGPVhV2/TjLaVE/koiCQHvDGrV2Z0YJxiMbRpyaT/DbuSHF81AIsHvG2MYxp0Y2NLKGpzBhgN3iJkP/fHYPLZ8wnASthNqklBCPEdsCuZFNS9gEoJ8ftjq364IMPz5Yat/uwKD6DmObRh+JzciNelGJOFn8n+H1frGFmy0FKqqtpGb2LmF5fRni7mJDd6RPxcbAvJweEZe4MnnMraRhaN8EUEQweHx6ObBg8B9bMQMn12CIlSK4wS3sWWZ4TQGhCilRZzFpmHmLDY9Mzex6Zm5if1rZi59IOrtF324t9efdL/pmMswM8Iuq6yHttgiKTNTbIgN5uSXpmUVPH+Bhx/txmjSPyShS5sdygM8AAAAAElFTkSuQmCC);
  }

  .howItWorks__step--two {
    margin: 24px auto;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABPCAIAAAD3BgWJAAAGY0lEQVR4Ae2bhZLbSBCG7wkPCo6ZOczMzMzMzJxlZrSXec2Mwr3/0s7EJFmVtRNZq64ul9SamepP04MafzA1I8XENrFNbBPbxDaxTewCi4ltYpvYJraJbWKb2Ca2IIkTEfdg0JZVx8MuWZb1iQHH4J6S54ACWhZsUZauD1b8WrH765ItKnrYcl+f2HBM3XOgARCYKdh7O2/jWU6dXXNIn9hwTIv/wHyD3ezuZw/+rT64ovFMVl3bfL7J1adPbDgG95Q8BxQDbHH3J7CPWB6Q6Zj1EbVegwmgjloeEiNgE9gbWy6TqcMzNGVQARoxAjaBvaHlIpm6fSNGxQYaMQI2G7aJHQpH2josbR3detOGprbK6vrhkbGCYK9cv+Ojz37Ss9579Dz/2LMXrkbR85etX7Fuu670s+/+TCYvCPbg0OiUzoQcO376EpHfB/nMwYZjj56WJMgfv5hB2Lhm5A+IXDv2Cetj3H9Xus0VCxQdNuThk5dEjleglAVoAAQmYBPYMZF7Nt5k9Y/huhixIahqWD7+/Ocnz8uUcgEQmIAlbAVRwJZkmZMEKJ+0gsWCjoy4YEYkIKPSPD/ER7EwwCpiMuKZJjbk3sNnRP68pFI9+9tgB/nINyVbES2zkhahZ/uewwI91fuUGefWHoHlp/Kd4M9cG9warsIjygXd1HrZEw9OBxty+/4TIi8pr8kzNmRl41nylfUFC+uOk2Ve7VGyeOMhsuzquJlZ8u3hKnqK9vbL672Ndc0XpokNuX77IR598sUv1bWNeca+PlRBjlbaO18RBuk2+V3UOCx0WzLZlpZdkiXaxvm7aj9qWJBEVDUlDnAR7djrNu/Ztf94pn7/21w8RZo8Y/cFxsnLkz2PcVtu68D1T2U7vy3ZyjhP9z6jNN6M0EXM1zmtD0br8UuW830vKLHGOF+yakvOeev3v83JMzaq67eKPfASsY3bQ933KJjXNJ3Hxf6uO/97Vn8S18saTuVksEe9VNr82qPylKwF2+lyl1bUlJRXZ9WrN+/D7Vl5r20I2Kh+0MP9VbWfKvn2cDUu/qjcG+Jj1O1dGyynARLRSxoX+eRy0IfPqj6ElN+Wbu3w5meTAw4XJMhZYEPRIbNgHg7Z04y9/nEkvthfwlr+zaEqVshQ0P5H5T4Yvy/dTgGvd2wfF369EbuHBTNC9J/qA7Q7S9WOQV4J2+Ib/aV8FyXGNSxFgA1Z1nCawVwdLCfjcesjZkSbT5vMsPlMk7vvh7IdSDOr+uBY2IX3RVoE2FcGygiPBTOkwdXLjNWObqWSl9Mry9CowOWkCsX5CX8kwgnvBxuRSb7+jmB+VYfUe6GhUhcV5mOFwB73hTsmvI5g9P1gI1x7A+NQRGmyHR0bjOiuVEpGp40+LFNRpjpzXBAH3UFgj3rDnCAVGFsHAuB+ZwDAydrrCPiinGGxRUm22HyE2ucMDLlD7HbMGzYstj/KEaQ9ECWL/Kpvm/RHJEk2LLY3Ek/GVhZjYQui1DX5JqpjvGh8bBJ03Fa7H9ishbvDccwCDY4NAaQrFEPvzeDxIqK88C6wg6Hw4RPnsZpX0nOXbkhSlhGV54WT566oZDx26mIsFtdU83FhwBUk8m6bD/18wbHrGlpgVFeshzNLGxoey5mxs7tH+5f6vtfV7otwBcdGTdY2NCst8aEdnRalAlvaOlUyNjS3Ke2xwop5uDMUQ8WygO9Nwjb4ANY54R10BTEzRasueJDroTPDiM1mZkwxXaXBrODYiEPEKrZjcyqSpQVtl6VXS0Z8tRcEMWt7jnICahvAI55QjKV5B9j1ja0watT6plaWcXh0XHtGfMHU18LTHwjuOXhy886DORXJkJhl5DgeI5+WjDv2Hp20OZS8QliP+cIYwwqPXVRiYqtiR4T4o9GGLu+IsbEBCEzAJrBx5pJ2v5wxv1GxgQZAYAJW+RCH4bBVzq6Y2Cb2nEVrlqzaXEQKh6eFvXrjLuQvUoXzb4kdiUa7rb1dluJTuA3nzYPVJjbDZidm2j2DRsUGGjECNoHN/j5y2PKAvl0aTAAFNGIEbAK71TNAJuiflfsW15/Mqisbz9Q7rfoEg2NwT8lzQDFAwCawIQe77xX1399mafv7GzATKzAWBjhnhA/0atloHq9LgWPqngMNgMBMwWbwjqhvLOzMqjhARsdLdChwDO4peQ4oBkzyHytm9H2b30B1AAAAAElFTkSuQmCC);
  }
  .howItWorks__step--three {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABPCAMAAABPumLsAAAC+lBMVEX////9/f64ur9wdn9UW2ZgZnCVmaDq6uzv7/B4fYVPVmFXXWjGyczm5+hkanNcY22QlZx1eoOws7jj5OZhZ3GFipHx8vO8v8OrrrP8/P3S1Ne/wsXY2tz4+Pnd3uBeZG7U1tlYXmmjp639/v7Iys29v8PFyMvw8PHc3uBobnhSWWSkp63MztLo6Oro6equsbZVXGaYnaPX2NtZX2qCh4/s7e7a2921uL2JjpVTWmWorLFbYWyPlJuXm6G5vMBjaXODiI98gorAw8fu7vBTWmR5f4fEx8rJy8/7+/vh4uSrr7TY2dz6+vrHys1udH2FipJWXGebn6Xr7O26vcHP0dS0t7yMkJhQV2LKzM+AhY2Gi5P6+vva295qcHlqcHr29vdaYWtscnxmbHaeoqjZ2t1zeIF1e4Px+vT6/fvJ7Nau4sFUwn1lyIrs+PDy+vXd8+Xk9erP7ttjyIhTwnyU2a2m4Lv3/PnB6dCw48OxtLni9emA0p9exoSj3rj5/frU8N5Xw3/r+O9axIGH1aTF6tKtsbbd3uHa8uN90Zz7/f1sy4/7/vy25cj1+/dqyo6I1aSBho645snZ8eJnyYtty5C+6M2R2KtzzpXT795ix4i55sq758ui3rjN7dnK7NZbxYLn9+3+//9Vw37X8eHD6tFyzZP0+/ag3bdoyo3S792c3LSZ27GN16iC06CK1aX9/v150Jl5z5lUwnxgx4alqa+ZnaOr4b980Zvf9Od2z5d3z5jf9OZnbXeprbJZxIBwzJJvzJHi4+WV2a9lyInv+fOP2KpexoX4/Prq9+9Vw32F1KLI69Xa3N6/6M/y8/T19fb5+fl/hIxxd4D8/f70+fvv9vns9Pjm8Pbg7fTe6/Pb6fLZ6PHa6fHc6vLf7PPk7/Xq8vf1+ftvdH36/P3w9vno8fbX5/DT5e/v9fnj7vV6gIj3+vzU5e/z+Pv4+/yQlJvi7fTq8/fW5vBmbHXU5u92fITl8Pbo8fefo6lkanTT1Ndscnulqa7Nz9LSlEiuAAAGyElEQVR4AcTUA5oDMBCG4b9uv7Vt27Zt27r/BdbW1G/0KE5G8eJwutwer0+R4w/wKCFRkZKUDCmpaUC6IiMjE7KypRw35CpUefkFBYVFelJcAl6HHpSWQXmFHlUkVVZV18iutg6gPtDQ2NTc0gptFXrS3gGdhV3dPb0lAH39FTLyD/BJecXbXB4+SZfRIAx1tw8PjvDIk6h3XaM8ah3rbyweHyBhQibZk0zpSfN0esvMrD6Zc84PLyzq0TTMy8QJS7KoyGRZJiusLspkDdZlMFtGp2waYUMGm7AlmyI3KzLYZmddRiv0Ge58d4c9We3C/oH+NLu5vUP9oawqAnDU49dvsp0rZUD9huzWjwFc5d36gX9wEmBn71DBOCk/5dHZrr6qHQBWO7fWFazF3aFzgAt9llcHU0uLCtHcxSo06pP8h0ihcNTW06tPCuBSYbni+tuQ7QrJze1z6/o6ZCEM6x+3d/d0loOTJUkYxPN8951tB85c21Zwwxscu8a2bdu2bc+/tLlV0zOPv4fsr7o7y/Dx8faCPT6+fv66M/6RCw6z9TemOBMQGHTkERyiSEiwDgJDw8JBIpgUCXJKJAr2vCWX4Uh0jK9SsXHxOkhIVJrEBAZJyUqlgM4vElNB0kTSYc/vIn/Bnoxkpcn0YpCVrQ7JzgFyqb7hyMunFvwMUijnX3Je+m7B4F9UVEzxKrFMwhh5U0uDgkop3kAZJTEH5ZSKcBB877zI/nm03VVWMWdqNZ8vqanlfzLfCqXWAXWUUCCcxQtDPYOGRjOFnGcP/hL5G6QpslkZyxhqi/FqBdpYrCwgi43XBqC9LBjtVfqW5lsXln+L3AbpUMpY/syW7ATQxbAbaGC9QUpZMBh6eKcXBlyWXx220u+eyGs6qc+yTKL0g+OIGoMB/g+CDCk1/DMIijkcRjxhwKjImP1J6nsRcwIYn5ho1paTNOkBYTh1bDnIiwGQn6d4FYHqzukZkGezInM45t1PRH6CRay2zNAVJvO69dgMCyCL7C0QlOnST7Ko2Tpe4rqZBos339MnKXvLaL6yzGiALw0ZqwFGtF4ECV9hfwWhSJFVM6d/PN6Cv3xL5HU62lt68tk+mDZluEZJABIoa7qBeNEBBFNiB6D57225cf/owPLpS3C0BIfIehaQasZ6K2W6vX3KGje8O5LHMVeuEhkb/ngqj0zRXpH3P4OTpZ4aRciaNsXb8KM2N/PPLx6Ea0guQDZpbDFmLZFn5QM4W+oBubW9wP/OAYY7vkrj682AYf5aDhzZtVrzNfnQ2ZJsq0N2ALLXoEjDHtzztTUUXxf53JUlG04XywcGz6Lu7iJPuGf/srx9AJA33pZXf3CyJFm5mSWlay3PW69nQLmyAAzAf5z8sc0T27Zt2327/bJ7fffKtEGz3mqdN7Zx73gmtsZz7+gE38Wpjg1Jhh3kWhQNIKfu0yf50fafIY3dUDKMXDYbZXfyk/ujjd1MmrpQMYbstQIlP9269Re0zBarze5wutwfeLw+fyAIvQ1kSDMWp5Gb0VA4EvUpah1L/a4wZxZqieXknvrkYnG32lgAWgn2/AN1G3l3aCQDXrVOKlUKk9Do1mDTXqG7wwifWsPjsNsiwbC5E4D4IZm2ZqDVRU6DzkrdccOmlrjjtqBAO2INs9BZRe5DjYj6gZKLhSHHxIvQWc3F+1GjM+q1pzsh7R45CxpiMregBZFJxx5E/Q6n1+txKw8VRXF7nVGBigHkTmgMJNeiEZG0BuJeRW0oior75BFoTCfnQyecDjg8aitxVD2iERozyEmastkcbrWZh8rDh4/zvZdE1RPegMZMcivKhP+hquN2xqO2SDqZCZtFqf/MYYGq3XWdMWsN1+0UujGZpzif2tIZgTYWdJC/QGstyRFH5k/EB4FSyXK2dBgS9gxLnCJ/7oKWGNafJHseOi1g9j12Pkv/ACl9nr9gXsdR1Nm29yDz+h2FPLF3Lkmuy75EY0ePHVpDXrwEaXtJvnq9tBta2HaWnAZZfeZy8ny0c+4CL5+DpOfkfLS3ijwNSS/4ChK2yd9Q95CvIaMHr0LOMNmb5zRyD6Qk8vcnGStrLhwTDdDrdkmgaOApZiHnCg/PBsZe/2b5ZHLQXc0wfZOYyzWmewPuA7s7yJeQM5+ce6NHT5b8/AfKxm5g2aMnk8kOyLrGonXLr12bQ16egKL9y8me66dlL7Lo56OQNn/1zZvrv/q2G4Dd98ipS5FnMJJzCkWetfOI8caWX7rwiX4h+88HcH8HGZqFL+Ib8tS9/8ZvIk2j8IUc284CYxe+mH0HSfZf2w1fkFh6bIBsEd8DSL4L9kuA8BcAAAAASUVORK5CYII=);
  }
  
  .howItWorks__step {
    flex: 1 1 auto;
    max-width: 100%;
    margin: 0 auto;
    padding: 150px 54px 60px;
    border-top: 6px solid #0097e6;
    border-radius: 4px;
    background-repeat: no-repeat;
    background-position: 50% 10%;
    text-align: center;
    box-shadow: 0 6px 20px 2px rgba(30, 30, 30, .1);
  }
  .getStartedRow {
    margin: 40px;
    text-align: center;
  }
  @media (min-width: 1024px) {
    .getStartedRow {
      margin: 60px 0 50px;
    }
  }
  @media (min-width: 500px) {
    .howItWorks__step {
      max-width: 70%;
    }
  }
  @media (min-width: 768px) {
    .howItWorks__steps {
      align-items: stretch;
      flex-flow: row nowrap;
    }
    .howItWorks__step {
      flex: 1 1 30%;
    }
    .howItWorks__step--two {
      margin: 0 24px;
    }
  }
  @media (min-width: 768px) {
    width: 750px;
  }
  @media (min-width: 992px) {
    width: 970px;
  }

  @media (min-width: 1024px) {
    width: 990px;
  }
  @media (min-width: 1200px) {
    width: 1170px;
  }
  @media (min-width: 1280px) {
    padding-left: 40px;
    padding-right: 40px;
    width: 1170px;
  }
  @media (min-width: 1600px) {
    padding-left: 115px;
    padding-right: 115px;
    width: 1440px;
  }
`;

function ApplicationStepsSection() {
  return (
    <StyledApplicationStepsSection>
      <div className="howItWorks__title">How it works</div>
      <div className="howItWorks__steps">
        <div className="howItWorks__step howItWorks__step--one">
          <div className="howItWorks__step-title">You answer simple questions</div>
          <div className="howItWorks__step-body">Choose your entity type and answer some basic questions. We’ll do the
            rest.
          </div>
        </div>
        <div className="howItWorks__step howItWorks__step--two">
          <div className="howItWorks__step-title">Get your EIN in 60 minutes!</div>
          <div className="howItWorks__step-body">It can take weeks for the IRS to mail it to you. We’ll email it in
            minutes!
          </div>
        </div>
        <div className="howItWorks__step howItWorks__step--three">
          <div className="howItWorks__step-title">File with<br/>Confidence</div>
          <div className="howItWorks__step-body">Don’t stress! Trained EIN specialists will review your data to make
            sure it complies with IRS standards.
          </div>
        </div>
      </div>
      <div className="getStartedRow">
      <Link href="#getStarted">
        <LinkButton>
          Get Started
        </LinkButton>
      </Link>
      </div>
    </StyledApplicationStepsSection>
  );
}

export default ApplicationStepsSection;
 
